module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "page-content hello"
  }, [_c('div', {
    staticClass: "page-bar"
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("关于平台")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/kylogo.jpeg"),
      "width": "20%"
    }
  })]), _c('h3', {
    staticStyle: {
      "text-align": "center",
      "color": "#888"
    }
  }, [_vm._v("门禁管理系统")]), _vm._v(" "), _c('p')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cae8116!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 305
// module chunks = 2 3